import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { fetchCancelledSales } from '../Sale/SaleAction';
import Pagination from '../Pagination/Pagination';

function CancelledSaleInvoice({ type }) {
    const { t, i18n } = useTranslation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage] = useState(10);

    const prevPage = () => setPage((p) => Math.max(1, p - 1));
    const nextPage = () => setPage((p) => p + 1);

    const pagesCount = Number.isFinite(total) ? Math.ceil(total / perPage) : 0;

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await fetchCancelledSales(page, perPage, null, null, null);
                setData(result?.data || []);
                setTotal(result?.total || 0);
            } catch (error) {
                console.error("Error fetching sales data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [type, page, perPage]);


    const groupedByInvoice = useMemo(() => {
        return data.reduce((acc, item) => {
            const invoiceNumber =
                item?.sale_invoice_detail?.sale_invoice?.invoice_number || "No Invoice";

            if (!acc[invoiceNumber]) {
                acc[invoiceNumber] = [];
            }

            acc[invoiceNumber].push(item);
            return acc;
        }, {});
    }, [data]);

    return (
        <div className='w-full h-full p-4 sm:p-6 md:p-10 bg-white overflow-x-auto'>
            <h1 className='text-2xl font-bold mb-5'>
                {t("cancelled")}
            </h1>

            {loading ? (
                <div className="text-center py-10">{t("loading")}...</div>
            ) : Object.keys(groupedByInvoice).length > 0 ? (
                Object.entries(groupedByInvoice).map(([invoiceNumber, items]) => (
                    <div key={invoiceNumber} className="mb-10">
                        <h2 className="text-lg font-semibold mb-3 bg-blue-600 text-white p-3 rounded">
                            {t("invoice")}: {invoiceNumber}
                        </h2>

                        <table className="min-w-[400px] sm:min-w-[600px] w-full bg-white border-collapse rounded-lg overflow-hidden text-xs sm:text-sm">
                            <thead>
                                <tr className="bg-gray-200 text-gray-700 text-xs sm:text-sm">
                                    <th className="p-1.5 sm:p-3 border">{t("item")}</th>
                                    <th className="p-1.5 sm:p-3 border">{t("quantity")}</th>
                                    <th className="p-1.5 sm:p-3 border">{t("meter")}</th>
                                    {/* <th className="p-3 border">{t("note")}</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item, idx) => (
                                    <tr key={item.id || idx} className="text-[11px] sm:text-sm">
                                        <td className="px-1.5 py-2 sm:px-3 sm:py-3 text-center border">
                                            {item?.sale_invoice_detail?.sale_invoice?.glass_type === 'double'
                                                ? (item?.sale_invoice_detail?.customer_note || '-')
                                                : (item?.sale_invoice_detail?.item?.name?.[i18n.language] || '-')
                                            }
                                        </td>
                                        <td className="px-1.5 py-2 sm:px-3 sm:py-3 text-center border">
                                            {item?.quantity || '-'}
                                        </td>
                                        <td className="px-1.5 py-2 sm:px-3 sm:py-3 text-center border">
                                            {item?.sale_item?.height || '-'} × {item?.sale_item?.width || '-'}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                ))
            ) : (
                <div className="text-center py-10 text-gray-500">
                    {t("no_data")}
                </div>
            )}

            {total > 0 && (
                <Pagination
                    page={page}
                    setPage={setPage}
                    showPage={pagesCount}
                    nextPage={nextPage}
                    prevPage={prevPage}
                />
            )}
        </div>
    );
}

export default CancelledSaleInvoice;